import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Chip from 'Chip';
import styles from './index.css';
import RecommendNewsBox from './recommendNewsBox/';
import TabsNewsStream from './tabsNewsStream/';
import MatchInfo from './matchInfo/';

const Content = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
            windowMode: PropTypes.string,
        };

        render() {
            const {
                content: {
                    sportsBestPic,
                    rightPicRec,
                    rightRecTitlePic,
                    bsInfoData,
                    initTabSwitchData,
                    ad_rightRec_01,
                    ad_rightRec_02,
                    ad_rightRec_03,
                    ad_slide,
                    ad_stream,
                    ad_hotNews,
                },
                windowMode,
            } = this.props;

            const recommendNewsData = {
                slideBoxData: sportsBestPic,
                recommendData: rightPicRec,
                rightRecTitlePic,
                ad_slide,
            };

            return (
                <div className={`${styles.responsiveBox} ${windowMode === 'wide' ? styles.wide : null}`}>
                    <div className={styles.competitionInfo}>
                        <Chip
                            id="30087"
                            type="struct"
                            title="头部比赛信息响应式"
                            groupName="content"
                            content={bsInfoData}>
                            <MatchInfo mode={windowMode} />
                        </Chip>
                    </div>
                    <div className={styles.contentBox}>
                        <RecommendNewsBox content={recommendNewsData} />
                        <TabsNewsStream
                            content={initTabSwitchData}
                            streamAdData={ad_stream}
                            rightAdData={{
                                ad_rightRec_01,
                                ad_rightRec_02,
                                ad_rightRec_03,
                                ad_hotNews,
                            }}
                        />
                    </div>
                </div>
            );
        }
    },
);

export { Content };
export default Content;
